import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  House,
  Grid,
  Folder,
  Box,
  ChevronDown,
  ChevronRight,
  X
} from "react-bootstrap-icons";


const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
  const [openMenu, setOpenMenu] = useState(null);
  
  const handleNavClick = () => {
  setSidebarOpen(false);
};

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  return (
    <>
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <h4>Admin</h4>
          <X className="close-btn d-md-none" onClick={() => setSidebarOpen(false)} />
        </div>

        <nav>

          {/* Dashboard */}
          <NavLink to="/admin/dashboard" className="nav-item1" onClick={handleNavClick}>
            <House className="icon" />
            <span>Dashboard</span>
          </NavLink>

          {/* Catalog Menu */}
          <div className="nav-item1 menu-parent" onClick={() => toggleMenu("catalog")}>
            <Grid className="icon" />
            <span>Catalog</span>
            {openMenu === "catalog" ? (
              <ChevronDown className="ms-auto" />
            ) : (
              <ChevronRight className="ms-auto" />
            )}
          </div>

          {openMenu === "catalog" && (
            <div className="submenu">
              <NavLink to="/admin/categories" onClick={handleNavClick}>Categories</NavLink>
              <NavLink to="/admin/subcategories" onClick={handleNavClick}>SubCategories</NavLink>
              <NavLink to="/admin/products" onClick={handleNavClick}>Products</NavLink>
              <NavLink to="/admin/variants" onClick={handleNavClick}>Variants</NavLink>
            </div>
          )}

          {/* Orders */}
          <NavLink to="/admin/orders" className="nav-item1" onClick={handleNavClick}>
            <Folder className="icon" />
            <span>Orders</span>
          </NavLink>

          {/* Inventory */}
          <NavLink to="/admin/sliders" className="nav-item1" onClick={handleNavClick}>
            <Box className="icon" />
            <span>Slider Images</span>
          </NavLink>

          {/* setting Menu */}
          <div className="nav-item1 menu-parent" onClick={() => toggleMenu("setting")}>
            <Grid className="icon" />
            <span>Setting</span>
            {openMenu === "setting" ? (
              <ChevronDown className="ms-auto" />
            ) : (
              <ChevronRight className="ms-auto" />
            )}
          </div>

          {openMenu === "setting" && (
            <div className="submenu">
              <NavLink to="/admin/shopdetails" onClick={handleNavClick}>Shop Details</NavLink>
              <NavLink to="/admin/invoicesetting" onClick={handleNavClick}>Invoice Setting</NavLink>
              <NavLink to="/admin/paymentsetting" onClick={handleNavClick}>Payment Setting</NavLink>
              <NavLink to="/admin/shippingsetting" onClick={handleNavClick}>Shipping Settings</NavLink>
            </div>
          )}

        </nav>
      </div>

      {sidebarOpen && <div className="overlay" onClick={() => setSidebarOpen(false)} />}
    </>
  );
};

export default Sidebar;